import React, { useContext } from 'react';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';
import ToolTip from '../../shared/ToolTip/ToolTip';

import { FormattedMessage, useIntl } from 'react-intl';

const InputElectricityRate = () => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);

  const label = intl.formatMessage({
    id: 'ev.electricityRate',
    defaultMessage: 'Electricity Rate ($/kWh)',
  });
  const tooltip = intl.formatMessage({
    id: 'ev.electricityRateTooltip',
    defaultMessage:
      'In a lease, you have to return the car after the lease period. In the case of loan financing, you keep the car after the loan is paid off.',
  });
  return (
    <>
      <label>{label}</label>
      <ToolTip
        message={
          intl.formatMessage
            ? intl.formatMessage({
                id: 'evs.availableNowTooltip',
                defaultMessage:
                  'Vehicles available now can be purchased for delivery, instead of just being open for pre-orders. Actual inventory may vary locally.',
              })
            : 'Vehicles available now can be purchased for delivery, instead of just being open for pre-orders. Actual inventory may vary locally.'
        }
        id="available-now-tooltip"
      />
      <div className="">
        <input
          value={Math.round(userPrefs.get('electricityRate')) / 100}
          className="form-control form-control-input"
          type="number"
          placeholder="0.0001"
          step={0.0001}
          min={0}
          max={100}
          maxLength={5}
          tooltip={tooltip}
          onChange={(e) => {
            if (e.target.value < 10) {
              const decimalRegex = /\.(\d{5,})$/;
              if (!decimalRegex.test(e.target.value.toString())) {
                userPrefs.set({ electricityRate: e.target.value * 100 });
              }
            }
          }}
          lang="en-150"
        />
      </div>

      <p>
        <FormattedMessage
          id="ev.electricityRateCalc"
          defaultMessage="Electricity rate is calculated as the average for six month of summer off-peak and six months off-peak for Rate A, the cheapest rate available for your zip code."
          description="Electricicty Rate Text"
        />
      </p>
    </>
  );
};

export default InputElectricityRate;
